import { Box, Avatar, Text, Flex, Tooltip, Grid, GridItem, Image, Popover, PopoverTrigger, } from "@chakra-ui/react";
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import MyDiv from "./attendanceProfile.style";
import { useState } from "react";
import { CustomToast } from '../../../../components';
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import { useEffect } from "react";
import { ProfileDetail, props } from "./modal";
import { useAuth } from "../../../../hooks/useAuth";
import PresenceIcon from "../../../../assets/images/PersenceIcon.svg";
import AbsenceIcon from "../../../../assets/images/AbsenceIcon.svg";
import LateIcon from "../../../../assets/images/LateIcon.svg";
import DateRangePicker from "../../../../components/DateRangePicker/DateRangePicker";
import FilterPopover, { IFilterOptions } from "../../../../components/FilterCard/filterCard";
import FilterIcon from '../../../../assets/images/Filter.svg';

const AttendanceProfile = ({ employeeId, attendanceData, onDateRangeChange, onFilterApply }: props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const { loginObj } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [employee, setEmployee] = useState<ProfileDetail | null>(null);
  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
  const cards = [
    { label: "Presence", icon: PresenceIcon, count: attendanceData?.summary?.totalPresent ?? 0 },
    { label: "Absence", icon: AbsenceIcon, count: attendanceData?.summary?.totalAbsent ?? 0 },
    { label: "Half day", icon: LateIcon, count: attendanceData?.summary?.totalHalfDay ?? 0 },
    { label: "Late + Early out", icon: LateIcon, count: attendanceData?.summary?.totalLateAndEarlyout ?? 0 },
    { label: "punch missing", icon: LateIcon, count: attendanceData?.summary?.totalpunchMissing ?? 0 },
  ];

  useEffect(() => {
    if (!employeeId) return;

    const fetchAvatar = async () => {
      try {
        const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employeeId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${loginObj?.token || ""}`,
          },
        });

        if (!res.ok) throw new Error("Avatar not found");

        const blob = await res.blob();
        if (blob.size > 0) {
          setAvatarUrl(URL.createObjectURL(blob));
        } else {
          setAvatarUrl(null);
        }
      } catch (err) {
        console.error("Error fetching avatar", err);
        setAvatarUrl(null);
      }
    };

    fetchAvatar();
  }, [employeeId]);

  useEffect(() => {
    profileDetail();
  }, [employeeId]);

  async function profileDetail() {
    const response = await fetchApi('Hrlense_Employee/profileCard', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setEmployee(response);
    }
  }

  const loadFilter = async () => {
    const response = await fetchApi("Filters/EmployeeAttendanceFilter", "GET")
    if (response) {
      setFilter(response)
    }
  }

  useEffect(() => {
    loadFilter();
  }, [])

  return (
    <MyDiv>
      <Box className="card" mb={4}>
        <Box px={3}>
          <Flex justify="space-between" align="center">
            <Flex align="center">
              <Avatar className="Avatar" src={avatarUrl ? avatarUrl : DummyPerson} name="" size="xl" mr={4} />
              <Box>
                <Flex gap={8}>
                  <Text className="font-poppins text_medium text_xl" mb={2}> {employee?.name} </Text>
                  <Text className="font-poppins text_medium text_lg" color={employee?.status === "Active" ? "#38A169" : "#E53E3E"} mb={2}>
                    {employee?.status}
                  </Text>

                </Flex>
                <Text className="font-poppins text_regular text_lg" mb={2}> {employee?.designation}</Text>
                <Flex gap={5}>
                  <Tooltip label={employee?.payrollCompany} aria-label="Full reason" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow >
                    <Text className="font-poppins text_medium text_md" maxWidth="18vw" isTruncated>Payroll Company:
                      <Text as="span" className="font-poppins text_regular text_md" px={1} > {employee?.payrollCompany} </Text>
                    </Text>
                  </Tooltip>
                  <Tooltip label={employee?.usCompany} aria-label="Full reason" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow >
                    <Text className="font-poppins text_medium text_md" maxWidth="15vw" isTruncated>Company:
                      <Text as="span" className="font-poppins text_regular text_md" px={1}> {employee?.usCompany} </Text>
                    </Text>
                  </Tooltip>
                  <Text className="font-poppins text_medium text_md">Branch:
                    <Text as="span" className="font-poppins text_regular text_md" px={1}> {employee?.branch} </Text>
                  </Text>
                  <Text className="font-poppins text_medium text_md">Department:
                    <Text as="span" className="font-poppins text_regular text_md" px={1}> {employee?.department}</Text>
                  </Text>
                  <Text className="font-poppins text_medium text_md">Shift:
                    <Text as="span" className="font-poppins text_regular text_md" px={1}> {employee?.shift} </Text>
                  </Text>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Box>
      <Box className="page_wrapper ">
        <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(5, 1fr)' }} gap={4}>
          {cards.map((card, index) => (
            <GridItem key={index} colSpan={1} className="card_box">
              <Flex align="center" gap={3} mb={2}>
                <Image src={card.icon} className="card_icon" alt={card.label} />
                <Text className="card_label font-poppins text_md text_medium">{card.label}</Text>
              </Flex>
              <Text className="card_value font-poppins text_bold">{card.count}</Text>
            </GridItem>
          ))}
        </Grid>
      </Box>
      <Flex justify="flex-end" align="center" gap={4}>
        <Box mt={4}>
          {onDateRangeChange && (
            <DateRangePicker onChange={onDateRangeChange} />
          )}
        </Box>
        <Popover placement="bottom-end" closeOnBlur >
          <PopoverTrigger>
            <Image src={FilterIcon} alt="Filter" className='icon_btn' />
          </PopoverTrigger>
          <FilterPopover
            filter={filter}
            onApplyFilter={(filters) => {
              const _filter: Record<string, number[]> = {};
              Object.keys(filters).forEach((key) => {
                if (filters[key].length > 0) {
                  _filter[key.replace(" ", "")] = filters[key];
                }
              });

              if (onFilterApply) {
                onFilterApply(_filter);
              }
            }}
          />
        </Popover>
      </Flex>

    </MyDiv>
  );
};

export default AttendanceProfile;
